import React from 'react';
import styled, { css } from 'styled-components';

import { Tooltip } from './tooltip';
import { basic } from '../../theme/colors';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode | React.ReactNode[];
  variant?: 'dark' | 'outline';
  block?: boolean;
  tooltip?: string;
}

const basicStyle = {
  fontSize: '.875rem',
  lineHeight: 1.5,
  borderRadius: '.2rem',
  display: 'inline-block',
  fontWeight: 400,
  verticalAlign: 'middle',
  backgroundColor: 'transparent',
  border: '1px solid transparent',
  padding: '0.25rem 0.5rem',
  textAlign: 'center',
  transition: `color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out`,
} as const;

const variantStyles = (variant = 'dark') =>
  ({
    dark: css`
      ${basicStyle}
      color: #fff;
      background-color: ${basic.haydenAnthracite2};
      border-color: ${basic.haydenAnthracite2};
      &:active {
        background-color: ${basic.haydenAlmostBlack};
        border-color: ${basic.haydenAlmostBlack};
      }
      &:hover {
        background-color: ${basic.haydenAnthracite3};
        border-color: ${basic.haydenAlmostBlack};
      }
      &:focus {
        background-color: ${basic.haydenAnthracite3};
        border-color: ${basic.haydenAlmostBlack};
        box-shadow: 0 0 0 0.2rem #52585d80;
      }
    `,
    outline: css`
      ${basicStyle}
      color:${basic.haydenAnthracite2};
      border-color: ${basic.haydenAnthracite2};
      border-width: 1px;
      &:active {
        color: #fff;
        background-color: ${basic.haydenAnthracite2};
        border-color: ${basic.haydenAnthracite2};
      }
      &:hover {
        color: #fff;
        background-color: ${basic.haydenAnthracite2};
        border-color: ${basic.haydenAnthracite2};
      }
      &:focus {
        box-shadow: 0 0 0 0.2rem #343a4080;
      }
    `,
  })[variant];

const StyledButton = styled.button<{
  variant?: 'dark' | 'outline';
}>`
  ${({ variant }) => variantStyles(variant)}
`;

export function SmallButton(props: ButtonProps) {
  if (props.tooltip) {
    return (
      <Tooltip tooltip={props.tooltip}>
        <StyledButton type="button" {...props}>
          {props.children}
        </StyledButton>
      </Tooltip>
    );
  }
  return (
    <StyledButton type="button" {...props}>
      {props.children}
    </StyledButton>
  );
}
